import PropTypes from 'prop-types';

export const propTypes = {
  locationInfo: PropTypes.object,
  locationInfoById: PropTypes.func,
  id: PropTypes.string,
};
